export { default } from './TouchFeedback';


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_rmc-feedback@2.0.0@rmc-feedback/es/index.js
// module id = 695
// module chunks = 0